import { ActionTypes } from '../actions/types';

export default function (
  state = [],
  action: { type: ActionTypes; payload?: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.SET_NOTIFICATION: {
      return payload;
    }

    default:
      return state;
  }
}
